<template>
  <SubmitForm
    :submissions="submissions"
    :students="students"
    :submissionStatus="submissionStatus"
    @save-status="updateStatus"
  />
</template>

<script>
import { mapGetters, mapMutations } from 'vuex';
import SubmitForm from '../components/SubmitForm.vue';

export default {
  components: { SubmitForm },
  computed: {
    ...mapGetters([
      'submissions', 'students', 'submissionStatus'
    ])

  },
  methods: {
    ...mapMutations([
      'saveStatus'
    ]),
    updateStatus(submissionStatus) { // 提出状況の更新
      // console.log('View:update');
      // console.log(submissionStatus);
      this.saveStatus(submissionStatus);
    }

  }
};
</script>